"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var EmptyTip_1 = require("./EmptyTip");
var LoadingTip_1 = require("./LoadingTip");
var ErrorTip_1 = require("./ErrorTip");
var FoundTip_1 = require("./FoundTip");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.StatusTip = forward_ref_with_statics_1.forwardRefWithStatics(function StatusTip(_a, ref) {
    var status = _a.status, emptyText = _a.emptyText, loadingText = _a.loadingText, errorText = _a.errorText, foundText = _a.foundText, clearResultText = _a.clearResultText, retryText = _a.retryText, onClear = _a.onClear, onRetry = _a.onRetry, hideIcon = _a.hideIcon, styledProps = tslib_1.__rest(_a, ["status", "emptyText", "loadingText", "errorText", "foundText", "clearResultText", "retryText", "onClear", "onRetry", "hideIcon"]);
    switch (status) {
        case "loading":
            return (react_1.default.createElement(LoadingTip_1.LoadingTip, tslib_1.__assign({ ref: ref }, styledProps, { loadingText: loadingText, hideIcon: hideIcon })));
        case "empty":
            return react_1.default.createElement(EmptyTip_1.EmptyTip, tslib_1.__assign({ ref: ref }, styledProps, { emptyText: emptyText }));
        case "found":
            return (react_1.default.createElement(FoundTip_1.FoundTip, tslib_1.__assign({ ref: ref }, styledProps, { foundText: foundText, onClear: onClear, clearResultText: clearResultText })));
        case "error":
            return (react_1.default.createElement(ErrorTip_1.ErrorTip, tslib_1.__assign({ ref: ref }, styledProps, { errorText: errorText, retryText: retryText, onRetry: onRetry, hideIcon: hideIcon })));
    }
    return null;
}, {
    LoadingTip: LoadingTip_1.LoadingTip,
    EmptyTip: EmptyTip_1.EmptyTip,
    FoundTip: FoundTip_1.FoundTip,
    ErrorTip: ErrorTip_1.ErrorTip,
});
exports.StatusTip.displayName = "StatusTip";
//# sourceMappingURL=StatusTip.js.map